const LARGE = 1024;
const MEDIUM = 650;
var currentType = '';

const toggleAccordions = () => {
  $( '.cell.download-list .dropdown' ).each( function() {
    let selector = $( this );

    

    selector.on( 'change', function(event) {

      if ( window.innerWidth >= LARGE ) {
        return;
      }
      
      var e = document.getElementById("dropdown");
      var selectedOption = e.options[e.selectedIndex].value;

      $('select.sub-dropdown').each(function() {
        $( this ).attr( 'style', 'display:none' );
      });

      $('select.sub-dropdown').parent().find(".resources-group").each(function() {
        $( this ).attr( 'style', 'display:none' );
      });
  
      selector.parent().find("[data-type='dropdown-"+selectedOption+"']").attr( 'style', 'display:block' );
      currentType = selectedOption;

      $( '.cell.download-list .sub-dropdown' ).trigger('change');

    });
    
  });
};


const toggleSubDropdown = () => {
  $( '.cell.download-list .sub-dropdown' ).each( function() {
    let selector = $( this );

    selector.on( 'change', function(event) {

      if ( window.innerWidth >= LARGE ) {
        return;
      }
      

      var e = document.getElementById(currentType);
      var selectedOption = e.options[e.selectedIndex].value;



      $('select.sub-dropdown').parent().find(".resources-group").each(function() {
        $( this ).attr( 'style', 'display:none' );
      });
      
      console.log(selectedOption);

      console.log(selector.parent().find("[data-product='"+selectedOption+"-content']"));
     
      selector.parent().find("[data-product='"+selectedOption+"-content']").attr( 'style', 'display:block' );


    });
  });
};

const searchBarResponsiveness = () => {
  
  if ( window.innerWidth >= MEDIUM ) {
    return;
  }
  var node1 = $(".section-subtitle :nth-child(1)");
  var node2 = $(".section-subtitle :nth-child(2)");
  var node3 = $(".section-subtitle :nth-child(3)");
  var node4 = $(".section-subtitle :nth-child(4)");

  $('.section-subtitle').empty();
  $('.section-subtitle').append(node1);
  $('.section-subtitle').append('|');
  $('.section-subtitle').append(node2);
  $('.section-subtitle').append(node3);
  $('.section-subtitle').append('|');
  $('.section-subtitle').append(node4);
};




$( document ).ready( function() {
  toggleAccordions();
  toggleSubDropdown();
  searchBarResponsiveness();
});

